import TuneIcon from '@mui/icons-material/Tune';
import { Button, Theme } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { CALENDAR_DEFAULT_VIEW } from '../../../sic-lib/defaults';
import { useAppSelector } from '../../../store/hooks';
import MenuCalendarViewRaw from './MenuCalendarViewRaw/MenuCalendarViewRaw';

const useStyles = makeStyles()((theme: Theme) => ({
    button: {
        padding: theme.spacing(1),
        color: theme.palette.btnDefault.main,
        '&:hover': {
            backgroundColor: theme.palette.btnDefault.light,
        },
    },
}));

export default function MenuCalendarView() {
    const { classes } = useStyles();

    const calendarView = useAppSelector(
        state => state.calendar?.calendarView || CALENDAR_DEFAULT_VIEW,
    );

    const [menuId] = React.useState<string>('menu_calendar_view');

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <Tooltip title="Switch Calendar View">
                <Button
                    onClick={handleOpen}
                    aria-haspopup="true"
                    aria-controls={menuId}
                    aria-expanded={Boolean(anchorEl)}
                    className={classes.button}
                    startIcon={<TuneIcon />}
                >
                    {calendarView}
                </Button>
            </Tooltip>
            {Boolean(anchorEl) && (
                <MenuCalendarViewRaw
                    anchorEl={anchorEl}
                    menuId={menuId}
                    onCloseHandler={handleClose}
                />
            )}
        </React.Fragment>
    );
}
